import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import { V2 } from "../drawerV2Tokens";

/** Remix RiMenuUnfoldLine — open sidebar */
function MenuUnfoldIcon({ size = 22 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M21 17.9995V19.9995H3V17.9995H21ZM17.4038 3.90332L22 8.49951L17.4038 13.0957L15.9896 11.6815L19.1716 8.49951L15.9896 5.31753L17.4038 3.90332ZM12 10.9995V12.9995H3V10.9995H12ZM12 3.99951V5.99951H3V3.99951H12Z" />
    </svg>
  );
}

/**
 * Mini-drawer only: open control placed above Assistance in the footer.
 * Matches the open-drawer fold control (icon only, no bg / padding).
 */
export default function DrawerOpenToggle() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  if (drawerOpen) return null;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 0.5 }}>
      <IconButton
        onClick={() => handlerDrawerOpen(true)}
        aria-label="Agrandir le menu"
        disableRipple
        sx={{
          color: V2.ink,
          flexShrink: 0,
          p: 0,
          borderRadius: 0,
          bgcolor: "transparent",
          "&:hover": {
            bgcolor: "transparent",
            color: V2.accent,
          },
        }}
      >
        <MenuUnfoldIcon size={22} />
      </IconButton>
    </Box>
  );
}
